import DarkModeIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeIcon from '@mui/icons-material/LightModeOutlined';
import SystemModeIcon from '@mui/icons-material/SettingsBrightnessOutlined';
import { t } from '../i18n/sq';

/** The colour modes offered in the account menu and in Settings → Aksesueshmëria. */
export const APPEARANCE = [
  { mode: 'light', label: t.appearance.light, icon: <LightModeIcon /> },
  { mode: 'dark', label: t.appearance.dark, icon: <DarkModeIcon /> },
  { mode: 'system', label: t.appearance.system, icon: <SystemModeIcon /> },
] as const;
